import React from "react";

import { Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import { CButton, CCol, CForm, CRow, CSpinner } from "@coreui/react";

/* <CustomeModalPopup
  open={rejectionWindowOpen} / * Show Model Popup handler * /
  onClose={handleRejectionWindowClose} / * Close  Model Popup handler * /
  onSubmitButton={RejectApiCall} / * Submit Button onClick Function call  * /
  onCloseButton={
    handleRejectionWindowClose
  } / * close Button onClick Function call  * /
  isSubmitBtnDisabled={
    false
  } / * any Api call on button that Time use if required * /
  disabledBtn={
    false
  } / * if  isSubmitBtnDisabled === true Then  disabledBtn  Value Check * /
  isFromSubmit={true} / * Means If From Submit Model open Or Normall Button * /
  body={""} / * Model Boday * /
  btnSubmitClass={""} / * Submit Button Default Class Set is success  * /
  btnSubmitText={""} / * Submit Button Default Text set is Submit * /
  btnCloseClass={""} / * Close Button Default Class Set is danager * /
  btnCloseText={""} / * Close Button Default Text Set is Close * /
/>; 
<CustomeModalPopup
  onOpen={handleWindowOpen} 
  onClose={handleWindowClose}
  onSubmitButton={onSubmit}
  onCloseButton={handleWindowClose}
  popupWith={400}
  body={""} 
  isFromSubmit={true} 
  isSubmitBtnDisabled={false} 
  ButtonLoader={false}
  disabledBtn={false} 
  btnSubmitClass={""} 
  btnSubmitText={""} 
  btnSubmitShow={true}
  btnCloseClass={""} 
  btnCloseText={""} 
  btnCloseShow={true}
heightSet={"90%"}
/>;

*/

const CustomeModalPopup = (props) => {
  const isValueCheck = (value, returnDefaultValue) => {
    return value === null || value === undefined || value === ""
      ? returnDefaultValue
      : value;
  };
  const popupWith = isValueCheck(props.popupWith, 400);

  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;

  const minHeightSet = isValueCheck(props.minHeight, 0);
  const heightSet = isValueCheck(props.heightSet, 0);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",

    width: popupWith,
    overflow: "auto",
    ...(heightSet !== 0 && { height: heightSet }),
    ...(minHeightSet !== 0 && { minHeight: minHeightSet }),
  };

  const isSubmitBtnDisabled = isValueCheck(props.isSubmitBtnDisabled, false);

  const ButtonLoader = isValueCheck(props.ButtonLoader, false);
  const isFromSubmit = isValueCheck(props.isFromSubmit, false);

  const btnSubmitClass = isValueCheck(props.btnSubmitClass, "success");

  const btnSubmitText = isValueCheck(props.btnSubmitText, "Submit");

  const btnSubmitShow = isValueCheck(props.btnSubmitShow, true);

  const btnCloseClass = isValueCheck(props.btnCloseClass, "danger");

  const btnCloseText = isValueCheck(props.btnCloseText, "Close");

  const btnCloseShow = isValueCheck(props.btnCloseShow, true);

  const onClose = (event, reason) => {
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      props.onClose();
    }
  };
  const onCloseButton = (event, reason) => {
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      props.onCloseButton();
    }
  };
  return (
    <Modal
      open={props.onOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropComponent={Backdrop}
    >
      <Paper style={style} elevation={3}>
        {isFromSubmit === true ? (
          <CForm className="needs-validation" onSubmit={props.onSubmitButton}>
            {props.body}

            {(btnSubmitShow === true || btnCloseShow === true) && (
              <CRow>
                <CCol style={props.btnCColstyle} className={props.btnCColClass}>
                  {props.footerBeforeBtn}
                  {btnSubmitShow === true &&
                    (isSubmitBtnDisabled === true ? (
                      <>
                        <CButton
                          className="mt-1"
                          color={btnSubmitClass}
                          type="submit"
                          disabled={ButtonLoader || props.disabledBtn}
                        >
                          {ButtonLoader && (
                            <>
                              <CSpinner
                                as="span"
                                size="sm"
                                aria-hidden="true"
                              />
                              &nbsp;
                            </>
                          )}
                          {btnSubmitText}
                        </CButton>
                      </>
                    ) : (
                      <CButton
                        className="mt-1"
                        color={btnSubmitClass}
                        type="submit"
                      >
                        {ButtonLoader && (
                          <>
                            <CSpinner as="span" size="sm" aria-hidden="true" />
                            &nbsp;
                          </>
                        )}
                        {btnSubmitText}
                      </CButton>
                    ))}

                  {btnCloseShow === true && (
                    <CButton
                      className="mt-1 ml-2 mr-2"
                      color={btnCloseClass}
                      type="button"
                      onClick={!ButtonLoader && onCloseButton}
                      disabled={ButtonLoader}
                    >
                      {btnCloseText}
                    </CButton>
                  )}
                </CCol>
              </CRow>
            )}
          </CForm>
        ) : (
          <CForm className="needs-validation">
            {props.body}
            {(btnSubmitShow === true || btnCloseShow === true) && (
              <CRow>
                <CCol style={props.btnCColstyle} className={props.btnCColClass}>
                  {props.footerBeforeBtn}
                  {btnSubmitShow === true &&
                    (isSubmitBtnDisabled === true ? (
                      <>
                        <CButton
                          className="mt-1"
                          color={btnSubmitClass}
                          type="button"
                          disabled={ButtonLoader || props.disabledBtn}
                          onClick={!ButtonLoader && props.onSubmitButton}
                        >
                          {ButtonLoader && (
                            <>
                              <CSpinner
                                as="span"
                                size="sm"
                                aria-hidden="true"
                              />
                              &nbsp;
                            </>
                          )}
                          {btnSubmitText}
                        </CButton>
                      </>
                    ) : (
                      <CButton
                        className="mt-1"
                        color={btnSubmitClass}
                        type="button"
                        disabled={ButtonLoader || props.disabledBtn}
                        onClick={!ButtonLoader && props.onSubmitButton}
                      >
                        {ButtonLoader && (
                          <>
                            <CSpinner as="span" size="sm" aria-hidden="true" />
                            &nbsp;
                          </>
                        )}
                        {btnSubmitText}
                      </CButton>
                    ))}
                  {btnCloseShow === true && (
                    <CButton
                      className="mt-1 ml-2 mr-2"
                      color={btnCloseClass}
                      type="button"
                      onClick={!ButtonLoader && onCloseButton}
                      disabled={ButtonLoader}
                    >
                      {btnCloseText}
                    </CButton>
                  )}
                </CCol>
              </CRow>
            )}
          </CForm>
        )}
      </Paper>
    </Modal>
  );
};

export default CustomeModalPopup;
